import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { AuthService } from 'src/app/providers/auth.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MessagingService } from 'src/app/providers/messaging.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { StorageService } from 'src/app/providers/storage.service';
import { CreateNewBusinessComponent } from 'src/app/shared/components/create-new-business/create-new-business.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit,OnDestroy {


  selectedLanguage : any = (localStorage.getItem('appLanguage')) ? localStorage.getItem('appLanguage') : 'en';
  selectLanguage : any;
  public loader: boolean = true;
  private _apiSubscription: Subscription;
  businessListData: {}[] = []
  userDetail: any

  constructor(private _storageService:StorageService,private _navService: NavigationService, private _apiService: ApiService, private loaderservice: LoaderServiceService, private _modelRef: MatDialog, private messagingService: MessagingService, private angularFireMessaging: AngularFireMessaging, private storageservicce: StorageService, private _router: Router, private _authservice: AuthService) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      
      if(resData.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT){
        this.userDetail = {}
        if(resData.result){
          if(!resData.result.profileHashId || resData.result.profileHashId == 'null'){
          this._authservice.onSignOut()
          }else{
            this.userDetail = resData.result
            localStorage.setItem(SM_CONSTANTS.OWNER_NAME, this.userDetail.name)
            localStorage.setItem(SM_CONSTANTS.PROFILE_HASH, this.userDetail.profileHashId)
            localStorage.setItem(SM_CONSTANTS.PROFILE_CODE, this.userDetail.profile_code)
            localStorage.setItem(SM_CONSTANTS.OWNER_IMAGE, this.userDetail.profileThumbImg)
            this._storageService.setLocalStorageValue(
              SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE,
              this.userDetail.country_code
            );
            this.loader = false;

        this.storageservicce.getValueFromLocalStorage(SM_CONSTANTS.KEY_FCM_TOKEN).then((value) => {
          console.log("valueiss",value);

          if(value && value != "null" && value != null){
            console.log("token exists");
            console.log("tokenvalueis:::", value);
            console.log("Notification granted value", Notification.permission);

            if(resData.result.fcm_token != localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || !resData.result.fcm_token){
              // if(true){
              // console.log("notEqualCheck", data.result.data[0].fcm_token != localStorage.getItem(UserConstants.KEY_FCM_TOKEN));
              // console.log("notExistCheck", data.result.data[0].fcm_token==null);

              if(Notification.permission == 'granted'){
                console.log("granted also true");

                let bodyData = {
                  fcmToken:  localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN),
                  
                }

                this._apiService.updateFcmTokenInfo(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),bodyData)
              } else {
                console.log("notification permission not granted");

              }


            }
          }

        });
          }
       
        }
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SUBSCRIPTION_INFO){ 
        // alert("calling from dashboard")
        if(resData.result){
          // this.ngOnInit()
          // window.location.reload()

          this._apiService.getBusinessList(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID))
          
        }
       }
      //  if(resData.responseType === SM_CONSTANTS.RESULT_API_VALIDATE_PAYMENT_SIGNATURE){ 
        
      //   if(resData.result){
      //     if(resData.result.signatureIsValid == "true"){
      //       this._apiService.getBusinessList(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID))
      //     }
      //   }
      //  }
      
    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
  }
//df
  ngOnInit(): void {
   
   
    this._apiService.getBusinessList(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID))
    this._apiService.getUserDetail(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID))
  

    
  }

  createNewBusiness(){
      // this._modelRef.open(CreateNewBusinessComponent, {
      //   width: '500px',
      //   data: {
      //     title: 'Create Business',
      //     ref: this._modelRef
      //   },
      // });
      this._router.navigate(['purchased-plan']);
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

}
